import {useTheme} from '@mui/material/styles';

const TabStyles = () => {
    const theme = useTheme();
    return {
        active:{
            color: theme?.color?.secondary,
            borderBottom: `${theme?.border?.medium} ${theme?.color?.secondary}`,
            cursor: theme?.cursor?.pointer,
        },
        hover:{
            "&:hover": {
                color: theme?.color?.secondary,
                cursor: "pointer",
              },
        }
    }
};

export default TabStyles;